"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetLoaderEvent = void 0;
class AssetLoaderEvent {
    constructor(type, groupName, qualityLevel, progress) {
        this.type = type;
        this.name = groupName;
        this.level = qualityLevel;
        this.progress = progress ? progress : 100;
    }
}
exports.AssetLoaderEvent = AssetLoaderEvent;
AssetLoaderEvent.LEVEL_COMPLETE = "levelComplete";
AssetLoaderEvent.ALL_LEVELS_COMPLETE = "allLevelsComplete";
AssetLoaderEvent.PROGRESS = "progress";
//# sourceMappingURL=AssetLoaderEvent.js.map